import { Label } from "@/components/ui/label";

export const Field = ({ label, children, className = "", required }) => (
  <div className={`space-y-2 ${className}`}>
    <Label className="text-xs tracking-[0.16em] uppercase text-white/60 font-medium">
      {label} {required && <span className="text-[#D4AF37]">*</span>}
    </Label>
    {children}
  </div>
);
